// extracted by mini-css-extract-plugin
export var modalContainer = "CookieSettingsContext-module--modalContainer--d1b81";